
// utils/periodeDominante.js
import { logDev } from "./logger.js";

// Détecte la période dominante parmi toutes les clés "periodeX" présentes
export const detectPeriodeDominante = (contacts = []) => {
  if (!Array.isArray(contacts)) {
    console.warn("detectPeriodeDominante: contacts n'est pas un tableau", contacts);
    return null;
  }
  if (!contacts.length) return null;

  // ✅ Déclaration correcte
  const totals = {};

  contacts.forEach(c => {
    if (Array.isArray(c.periodes)) {
      c.periodes.forEach(p  => {
        const val = Number(p?.valeur || 0);
        if (val > 0) {
          // 👉 on utilise directement l'ID de la période comme clé
          totals[p.periodeId] = (totals[p.periodeId] || 0) + Number(c.combien || 1);
        }
      });
    }
  });

  const keys = Object.keys(totals);
  if (keys.length === 0) return null;

   const winningKey = keys.reduce((a, b) => (totals[a] > totals[b] ? a : b));
  
   logDev("[detectPeriodeDominante] résultat", { totals, winningKey });

   return winningKey; // 👉 renvoie un periodeId MongoDB
};

// Trouve la période max pour une ligne donnée
export const getMaxPeriodeKey = (row = {}) => {
  const values = Object.entries(row)
    .filter(([k]) => !["contact", "_id"].includes(k))
    .reduce((acc, [k, v]) => {
      acc[k] = parseFloat(v || 0);
      return acc;
    }, {});

  const keys = Object.keys(values);
  if (keys.length === 0) return null;
  return keys.reduce((a, b) => (values[a] > values[b] ? a : b));
};

// Calcule le total pour un champ donné
export const calculateTotal = (contacts, periodeId) => {
  if (!Array.isArray(contacts)) return 0;
  return contacts.reduce((sum, row) => {
    //const vote = row.periodes?.find(p => p.periodeId === periodeId);
    return sum + Number(row[periodeId] || 0); // ✅ lecture directe
  }, 0);
};

// Trouve la période max dans une ligne "total"
export const getMaxPeriodeInTotal = (row = {}) => {
  const values = Object.entries(row)
    .filter(([k]) => !["contact", "_id"].includes(k))
    .reduce((acc, [k, v]) => {
      acc[k] = parseFloat(v || 0);
      return acc;
    }, {});
  const keys = Object.keys(values);
  if (keys.length === 0) return null;
  return keys.reduce((a, b) => (values[a] > values[b] ? a : b));
};
